module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAABEUlEQVQoU82Rzy4DYRTFz5kxikQQG4kNz6CJibajH4mkzJfQhddoIrG3tmssbbyBP6VEOm3FlIiNlS0LC110MSvEmCuzIISOrbu9v3PvuffQ1+oaQBrJ9ZiZmh3nH9C3Nn2dtwEuUCRBaFxmDuun9LVqC2TbELx22yJkqSfsm4hhyVYaiXZaWt0LTOe/wmfamaRh9Tv73u3Hwb969rVaBbAFIBTKZu6gWY4FP+CWq9aEKBmG6UbRc0BYVYAnM5X6+oVWd5/fIFmGYM4Mo0X7uPkQT2ss54d737gnQBuCHGja9F3VIXGTejKL6Vot+BpMtVBIDVkvOxApDkYDYzxfyo54R36wAUTdErxamR+d3vU677Bhhon82iY/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide/zhanl.png
// module id = +tJc
// module chunks = 1